import Slider from '../helpers/Slider';

;$(function() {

    $('[id*=lot_slider]').each(function() {
        if (/_pagination$/gi.test($(this).attr('id')))
            return;

        new Slider($(this));
    });

});